export const MESSAGES = {
  NO_RESULTS: `No results found`,
  FUZZY_NO_RESULTS: (query) =>
    `Nothing found for: "${query}". Here are similar results`,
  SEARCH_INFO: `Your search results for:`,
  VIEW_ALL: `View all`,
}
